export const queryStringToObject = (queryString) => {
    return queryString
        .replace(/^\?/, '') // Enlève le '?' initial s'il est présent
        .split('&')
        .reduce((acc, param) => {
            const [key, value] = param.split('=').map(decodeURIComponent);
            if (key) {
                if (acc[key]) {
                    // Si la clé existe déjà, assurez-vous qu'elle est un tableau
                    if (!Array.isArray(acc[key])) {
                        acc[key] = [acc[key]];
                    }
                    acc[key].push(value);
                } else {
                    // Si la clé n'existe pas, ajoutez simplement la valeur
                    acc[key] = value;
                }
            }
            return acc;
        }, {});
}